import { MinzeElement, Attrs } from 'minze'
import { Locale } from '../../modules/locale'

export interface LvcAccountFavoritesGrid {
  data: string
  gridTemplate: string
  tabletGridTemplate: string
  mobileGridTemplate: string
}

export class LvcAccountFavoritesGrid extends MinzeElement {
  attrs: Attrs = [
    ['data', ''],
    ['grid-template', '1fr 1fr 1fr 1fr'],
    ['tablet-grid-template', '1fr 1fr'],
    ['mobile-grid-template', '1fr'],
  ]
  parsedData: any[] = []
  static observedAttributes = ['data']

  onReady = () => {
    this.parsedData = JSON.parse(decodeURIComponent(this.data))
    this.rerender()
  }

  html = () => `
    ${this.parsedData
      .map((item: any) => {
        return /* html */ `
        <lvc-favorite-item
          data-id="${item.id}"
          data-type="${item.schema}"
          data-url="${item.urlConstruct?.[Locale.language]}"
          data-image-url="${item.image.url}"
          data-image-alt="${item?.image.url?.[Locale.language]}"
        >
          <span slot="title">${item?.name?.[Locale.language]}</span>
          <span slot="date">${item.eventCount || 0} ${Locale.getPluralKey('favoritesList.eventsCount', item.eventCount || 0)}</span>
        </lvc-favorite-item>
      `
      })
      .join('')}
  `

  css = () => `
    :host {
      display: grid;
      grid-template-columns: ${this.mobileGridTemplate};
      column-gap: 20px;
      row-gap: 60px;
      padding-top: 40px;
    }

    @media only screen and (min-width: 768px) {
      :host {
        grid-template-columns: ${this.tabletGridTemplate};
      }
    }

    @media only screen and (min-width: 1200px) {
      :host {
        grid-template-columns: ${this.gridTemplate};
      }
    }
  `
}
